import { Chess, createPlayableBoard, refreshPlayableBoard } from './chess-ui.js';

const root = document.querySelector('[data-daily-puzzle]');
if (root) {
  const initialFen = root.dataset.fen;
  const solution = String(root.dataset.solution ?? '').toLowerCase().trim().split(/[\s,;]+/).filter(Boolean);
  const game = new Chess(initialFen);
  const feedback = root.querySelector('[data-daily-feedback]');
  let cursor = 0;
  let locked = false;
  const ground = createPlayableBoard(root.querySelector('#dailyPositionBoard'), game, onMove, {
    orientation: game.turn() === 'w' ? 'white' : 'black', refreshAfterMove: false
  });

  root.querySelector('[data-daily-reset]')?.addEventListener('click', reset);
  root.querySelector('[data-daily-answer]')?.addEventListener('click', showAnswer);
  const turn = root.querySelector('[data-daily-turn]');
  if (turn) turn.textContent = game.turn() === 'w' ? 'سفید حرکت می‌کند' : 'سیاه حرکت می‌کند';

  async function onMove(move) {
    if (locked) { game.undo(); refreshPlayableBoard(ground, game, false); return; }
    const uci = `${move.from}${move.to}${move.promotion ?? ''}`.toLowerCase();
    if (uci !== solution[cursor]) {
      game.undo();
      feedback.textContent = 'این حرکت جواب معما نیست؛ دوباره تلاش کن.';
      feedback.className = 'daily-position-feedback error';
      refreshPlayableBoard(ground, game, true);
      return;
    }
    cursor++;
    feedback.textContent = 'حرکت درست بود!';
    feedback.className = 'daily-position-feedback success';
    refreshPlayableBoard(ground, game, false, [move.from, move.to]);
    if (cursor >= solution.length) { finish(); return; }
    locked = true;
    await delay(420);
    const reply = playUci(solution[cursor++]);
    if (reply) refreshPlayableBoard(ground, game, false, [reply.from, reply.to]);
    if (cursor >= solution.length) { finish(); return; }
    locked = false;
    feedback.textContent = 'ادامه درست را پیدا کن.';
    feedback.className = 'daily-position-feedback';
    refreshPlayableBoard(ground, game, true);
  }

  function finish() {
    locked = true;
    feedback.textContent = 'آفرین؛ معمای روز را حل کردی!';
    feedback.className = 'daily-position-feedback success';
    refreshPlayableBoard(ground, game, false);
  }
  function reset() {
    game.load(initialFen); cursor = 0; locked = false;
    feedback.textContent = root.dataset.title || 'بهترین ادامه را پیدا کن.';
    feedback.className = 'daily-position-feedback';
    refreshPlayableBoard(ground, game, true);
  }
  async function showAnswer() {
    game.load(initialFen); cursor = 0; locked = true; refreshPlayableBoard(ground, game, false);
    for (const uci of solution) {
      const move = playUci(uci); if (!move) break;
      cursor++; refreshPlayableBoard(ground, game, false, [move.from, move.to]); await delay(500);
    }
    feedback.textContent = `جواب: ${solution.join(' ')}`;
    feedback.className = 'daily-position-feedback warning';
  }
  function playUci(uci) { return game.move({ from: uci.slice(0, 2), to: uci.slice(2, 4), promotion: uci[4] || 'q' }); }
}
function delay(ms) { return new Promise(resolve => setTimeout(resolve, ms)); }
